"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasProperty = void 0;
function hasProperty(value, prop) {
    return !!value[prop];
}
exports.hasProperty = hasProperty;
//# sourceMappingURL=hasProperty.js.map